module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg0-c896ec3e12abeae25b23f0718eceb23b.jpg";